import type { AxiosInstance } from 'axios';

export default class AttendanceTagsApi {
  constructor(private readonly http: AxiosInstance) {}

  async addAttendanceTagToAgent(
    protocol: number,
    tagId: number,
    body: { channel: string; agentId: number },
  ) {
    try {
      const { data } = await this.http.post(
        `/new-tag/agent/job/${protocol}/add-tag/${tagId}`,
        body,
      );

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }

  async removeAttendanceTagToAgent(
    protocol: number,
    tagId: number,
    body: { channel: string; agentId: number },
  ) {
    try {
      const { data } = await this.http.post(
        `/new-tag/agent/job/${protocol}/remove-tag/${tagId}`,
        body,
      );

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }

  async deleteTagFromContact(
    contactId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    try {
      const { data } = await this.http.delete(
        `/new-tag/agent/contacts/${contactId}/tag-items/${tagItemId}?agentId=${agentId}`,
      );

      return data;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error);
    }
  }
}
